<template>
  <div class="paginator">
    <span class="previous" :class="{disabled: previous === null}" @click.prevent="$emit('paginate', previous)"><icon name="caret-right" /></span>
    <slot />
    <span class="next" :class="{disabled: next === null}" @click.prevent="$emit('paginate', next)"><icon name="caret-left" /></span>
  </div>
</template>

<script>
  export default {
    props: ['next', 'previous'],
  };
</script>

<style lang="scss" scoped>
  @import '../variables';
  .paginator {
    margin-top: auto;
    direction: rtl;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .next {
      color: $gray-500;
    }
    .previous {
      color: $gray-500;
    }
    span {
      color: $gray-400;
      cursor: pointer;
      &:hover {
        color: $gray-800;
      }
      &.disabled {
        cursor: default;
        color: $gray-200;
        &:hover {
          color: $gray-200;
        }
      }
    }
  }
</style>
